import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Certification } from './components/Certification';
import { Products } from './components/Products';
import { Customers } from './components/Customers';
import { Technical } from './components/Technical';
import { GetQuote } from './components/GetQuote';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <About />
      <Certification />
      <Products />
      <Customers />
      <Technical />
      <GetQuote />
      <Contact />
      <Footer />
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
